/* eslint-disable */
import { Component, Vue } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import QueryableInterface from "@/interfaces/QueryableInterface";
import Base from "./Base";

@Component
export default class AlertFeedMixin extends Base {
  getAlertFeeds(params: QueryableInterface, tag: string) {
    const queryString = this.paramsToQueryString(params);
    const url = API_ENDPOINT + `/me/alert_feeds.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }
}
